var image_viewer_default = {
  "fontElementMap": "_2NebI",
  "imageContainer": "MNXlj",
  "expandButton": "UW2Tf",
  "expandIcon": "tozwo",
  "pointer": "HPjNG",
  "imageWrapper": "-OYpk",
  "imageRatio": "rMVZc",
  "image": "_6bvf1",
  "imageOverlay": "Axyh0",
  "imagePreload": "_9XtMU",
  "imageHighres": "UASOU",
  "onlyHighRes": "SqBQK",
  "image_loading": "_21NTy"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
